function LedgerAccount() {
    return (
        <div>
            <h2>Ledger Account</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default LedgerAccount;